// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 6.4998V17.4998L1 17.5L1 6.5L5 6.4998Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 18.2099L15.0004 22.7095L15.0004 1.29004L7 5.7896V18.2099Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.3889 8.10994L18.6818 7.40283L17.2676 8.81705L17.9747 9.52415C19.3415 10.891 19.3415 13.1071 17.9747 14.4739L17.2676 15.181L18.6818 16.5952L19.3889 15.8881C21.5368 13.7402 21.5368 10.2578 19.3889 8.10994Z"}}]};

const SoundLowFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sound-low-filled',
    ref,
    icon: element,
  },
));

SoundLowFilledIcon.displayName = 'SoundLowFilledIcon';

export default SoundLowFilledIcon;
